import React from 'react'
import styled from 'styled-components';

const StyledInfoPage = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 100px;
   
    @media (max-width: 1200px) {
        flex-direction: column;
        align-items: center;
        padding: 0 2em 2em 2em ;
    }
    
`;

const StyledInfo = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 500px;
    font-family: kenoky;

    &>span {
        height: 1px;
        background-color: black;
        width: 90%;
        margin: 1em 0 2em 0;
    }
    &>h1 {
        font-size: 3rem;
        font-weight: 100;
    }
    &>p, &>a {
        font-size: 1.3rem;
    }


`;

const StyledPics = styled.div`
position: relative;
`;

const StyledPortrait = styled.img`
  height: 50vh;
  transform: perspective(1500px) rotateY(-15deg);
  transition: all .5s;
  opacity: 0.6;
  
  &:hover {
    transform: perspective(3000px) rotateY(-5deg);
    opacity: 1;
  }

  @media (max-width: 1200px) {
    transform: none;
    opacity: 1;
  }

  `;

export default function InfoPage({ children, pic }) {
    return (
        <StyledInfoPage>
            <StyledInfo>
                {children}
            </StyledInfo>
            <StyledPics>
                <a href='https://www.linkedin.com/in/jonathanrobertwolf/' target="_blank" rel="noreferrer"><StyledPortrait src={pic} alt="a photo of Jonathan Wolf" /></a>
            </StyledPics>
        </StyledInfoPage>
    )
}
